<div class="documentos-container">
    <form [formGroup]="documentosForm">
        <app-card-content [border]="false" [headerColor]="true" icon="pi pi-file" title="Documentos" subtitle="Documentos de identificação">
            <div card-header>
                <app-botao-acoes [label]="'Ações'" [items]="acoesFormulario" [destaque]="itensEdicao" [destaqueAtivo]="modoEdicao" [appCan]="roleDocumentosEditar" [appCanUf]="pessoa()?.uf" [permissaoUf]="pessoa()?.uf ?? null"></app-botao-acoes>
            </div>

            <div class="flex flex-col gap-4">
                <!-- CPF -->
                <app-card-content [headerColor]="false" icon="pi pi-id-card" title="CPF">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div class="field">
                            <label for="cpfNumero" class="font-semibold block mb-2">Número CPF *</label>
                            <p-inputmask id="cpfNumero" formControlName="cpfNumero" mask="999.999.999-99" placeholder="000.000.000-00" styleClass="w-full readonly-input" [readonly]="true" />
                            @if (campoInvalido('cpfNumero')) {
                                <small class="erro-campo">{{ mensagemErroCampo('cpfNumero') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- RG -->
                <app-card-content [headerColor]="false" icon="pi pi-user" title="RG (Registro Geral)">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                        <div class="field">
                            <label for="rgNumero" class="font-semibold block mb-2">Número RG</label>
                            <input
                                pInputText
                                id="rgNumero"
                                formControlName="rgNumero"
                                placeholder="Número do RG"
                                maxlength="16"
                                inputmode="numeric"
                                pattern="[0-9]*[Xx]?"
                                [attr.aria-invalid]="campoInvalido('rgNumero') ? true : null"
                                [attr.aria-describedby]="campoInvalido('rgNumero') ? 'erro-rgNumero' : null"
                                [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [readonly]="!modoEdicao"
                            />
                            @if (campoInvalido('rgNumero')) {
                                <small class="erro-campo" [id]="'erro-rgNumero'">{{ mensagemErroCampo('rgNumero') }}</small>
                            }
                        </div>
                        <div class="field">
                            <label for="rgDataEmissao" class="font-semibold block mb-2">Data Emissão</label>
                            <p-inputmask id="rgDataEmissao" formControlName="rgDataEmissao" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                            @if (campoInvalido('rgDataEmissao')) {
                                <small class="erro-campo">{{ mensagemErroCampo('rgDataEmissao') }}</small>
                            }
                        </div>
                        <div class="field">
                            <label for="rgOrgaoEmissor" class="font-semibold block mb-2">Órgão Emissor</label>
                            <input pInputText id="rgOrgaoEmissor" formControlName="rgOrgaoEmissor" placeholder="Ex: SSP" maxlength="10" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                            @if (campoInvalido('rgOrgaoEmissor')) {
                                <small class="erro-campo block mt-1">{{ mensagemErroCampo('rgOrgaoEmissor') }}</small>
                            }
                        </div>
                        <div class="field">
                            <label for="rgUF" class="font-semibold block mb-2">UF</label>
                            <app-estado-select [uf]="documentosForm.get('rgUF')?.value ?? ''" (ufChange)="documentosForm.patchValue({ rgUF: $event })" [disabled]="!modoEdicao" />
                            @if (campoInvalido('rgUF')) {
                                <small class="erro-campo block mt-1">{{ mensagemErroCampo('rgUF') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- Título de Eleitor -->
                <app-card-content [headerColor]="false" icon="pi pi-check-square" title="Título de Eleitor">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                        <div class="field">
                            <label for="tituloNumero" class="font-semibold block mb-2">Número</label>
                            <input pInputText id="tituloNumero" formControlName="tituloNumero" placeholder="Número do título" maxlength="14" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                        </div>
                        <div class="field">
                            <label for="tituloZona" class="font-semibold block mb-2">Zona</label>
                            <input pInputText id="tituloZona" formControlName="tituloZona" placeholder="Zona" maxlength="4" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                            @if (campoInvalido('tituloZona')) {
                                <small class="erro-campo block mt-1">{{ mensagemErroCampo('tituloZona') }}</small>
                            }
                        </div>
                        <div class="field">
                            <label for="tituloSecao" class="font-semibold block mb-2">Seção</label>
                            <input pInputText id="tituloSecao" formControlName="tituloSecao" placeholder="Seção" maxlength="4" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                            @if (campoInvalido('tituloSecao')) {
                                <small class="erro-campo block mt-1">{{ mensagemErroCampo('tituloSecao') }}</small>
                            }
                        </div>
                        <div class="field">
                            <label for="tituloUF" class="font-semibold block mb-2">UF</label>
                            <app-estado-select [uf]="documentosForm.get('tituloUF')?.value ?? ''" (ufChange)="documentosForm.patchValue({ tituloUF: $event })" [disabled]="!modoEdicao" />
                            @if (campoInvalido('tituloUF')) {
                                <small class="erro-campo block mt-1">{{ mensagemErroCampo('tituloUF') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- RNE (condicional) -->
                @if (mostrarRne) {
                    <app-card-content [headerColor]="false" icon="pi pi-globe" title="Registro Nacional de Estrangeiros">
                        <div class="flex flex-col gap-4">
                            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                                <div class="field">
                                    <label for="rneNumero" class="font-semibold block mb-2">RNE Número</label>
                                    <input pInputText id="rneNumero" formControlName="rneNumero" placeholder="Número RNE" maxlength="20" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                                </div>
                                <div class="field">
                                    <label for="rneDataEmissao" class="font-semibold block mb-2">Data Emissão</label>
                                    <p-inputmask id="rneDataEmissao" formControlName="rneDataEmissao" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                                    @if (campoInvalido('rneDataEmissao')) {
                                        <small class="erro-campo">{{ mensagemErroCampo('rneDataEmissao') }}</small>
                                    }
                                </div>
                                <div class="field">
                                    <label for="rneDataValidade" class="font-semibold block mb-2">Data Validade</label>
                                    <p-inputmask id="rneDataValidade" formControlName="rneDataValidade" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                                    @if (campoInvalido('rneDataValidade')) {
                                        <small class="erro-campo">{{ mensagemErroCampo('rneDataValidade') }}</small>
                                    }
                                </div>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div class="field">
                                    <label for="passaporteNumero" class="font-semibold block mb-2">Passaporte Número</label>
                                    <input pInputText id="passaporteNumero" formControlName="passaporteNumero" placeholder="Número do passaporte" maxlength="16" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                                </div>
                                <div class="field">
                                    <label for="tipoRegistro" class="font-semibold block mb-2">Tipo de Registro</label>
                                    <p-select
                                        [appendTo]="'body'"
                                        id="tipoRegistro"
                                        formControlName="tipoRegistro"
                                        [options]="opcoesTipoRegistro"
                                        optionLabel="label"
                                        optionValue="value"
                                        placeholder="Selecione"
                                        [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                        [readonly]="!modoEdicao"
                                    />
                                </div>
                            </div>
                        </div>
                    </app-card-content>
                }

                <!-- Certificado Militar -->
                <app-card-content [headerColor]="false" icon="pi pi-shield" title="Certificado Militar">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                        <div class="field">
                            <label for="certificadoMilitarNumero" class="font-semibold block mb-2">Número</label>
                            <input
                                pInputText
                                id="certificadoMilitarNumero"
                                formControlName="certificadoMilitarNumero"
                                placeholder="Número do certificado"
                                maxlength="16"
                                [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [readonly]="!modoEdicao"
                            />
                        </div>
                        <div class="field">
                            <label for="certificadoMilitarCategoria" class="font-semibold block mb-2">Região Militar</label>
                            <input
                                pInputText
                                id="certificadoMilitarCategoria"
                                formControlName="certificadoMilitarCategoria"
                                placeholder="Região Militar"
                                maxlength="14"
                                [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [readonly]="!modoEdicao"
                            />
                        </div>
                        <div class="field">
                            <label for="situacaoMilitar" class="font-semibold block mb-2">Situação Militar</label>
                            <p-select
                                [appendTo]="'body'"
                                id="situacaoMilitar"
                                formControlName="situacaoMilitar"
                                [options]="situacaoMilitarOptions"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Selecione"
                                [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [readonly]="!modoEdicao"
                            />
                        </div>
                        <div class="field">
                            <label for="ministerio" class="font-semibold block mb-2">Ministério</label>
                            <p-select
                                [appendTo]="'body'"
                                id="ministerio"
                                formControlName="ministerio"
                                [options]="ministerioOptions"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Selecione"
                                [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [readonly]="!modoEdicao"
                            />
                        </div>
                    </div>
                </app-card-content>
            </div>
        </app-card-content>
    </form>
</div>
